export enum SUPPORTED_FONT_FAMILY {
  MODERAT = 'MODERAT',
  PP_FRAGMENT = 'PP_FRAGMENT',
}

const PP_FRAGMENT = SUPPORTED_FONT_FAMILY.PP_FRAGMENT

export enum FFM_COMPONENT_KEY {
  BASE_TEXT = 'BASE_TEXT',
}

export enum FFM_COMPONENT_PROP_KEY {
  HEADLINE = 'HEADLINE',
  SUBHEAD = 'SUBHEAD',
  DEFAULT = 'DEFAULT',
}

export type FontFamilyMetadata = {
  default: SUPPORTED_FONT_FAMILY
  isAuroraMetadata: boolean
  component?: {
    [FFM_COMPONENT_KEY.BASE_TEXT]?: {
      [FFM_COMPONENT_PROP_KEY.HEADLINE]: SUPPORTED_FONT_FAMILY
      [FFM_COMPONENT_PROP_KEY.SUBHEAD]: SUPPORTED_FONT_FAMILY
    }
  }
}

export const defaultModeratFontFamilyMetadata: FontFamilyMetadata = {
  default: SUPPORTED_FONT_FAMILY.MODERAT,
  isAuroraMetadata: false,
}

export const auroraFontFamilyMetadata: FontFamilyMetadata = {
  ...defaultModeratFontFamilyMetadata,
  isAuroraMetadata: true,
  component: {
    [FFM_COMPONENT_KEY.BASE_TEXT]: {
      [FFM_COMPONENT_PROP_KEY.HEADLINE]: PP_FRAGMENT,
      [FFM_COMPONENT_PROP_KEY.SUBHEAD]: PP_FRAGMENT,
    },
  },
}

export const getFontFamilyFromMetadata = (
  fontFamilyMetadata: FontFamilyMetadata,
  componentKey?: FFM_COMPONENT_KEY,
  componentPropKey?: FFM_COMPONENT_PROP_KEY,
): SUPPORTED_FONT_FAMILY => {
  if (componentKey && componentPropKey && fontFamilyMetadata.component) {
    const componentKeyMapping = fontFamilyMetadata.component[componentKey]
    if (componentKeyMapping) {
      const componentPropKeyMapping = componentKeyMapping[componentPropKey]
      if (componentPropKeyMapping) {
        return componentPropKeyMapping
      }
    }
  }

  return fontFamilyMetadata.default
}
